
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import LoginStore from '@/login/store';
import { store } from '@/store';

getModule(LoginStore, store);

@Component
export default class Topbar extends Vue {
	get headline() {
		return this.$store.state.login.headline;
	}

	get hasSubtitle() {
		return this.$store.state.login.hasSubtitle;
	}

	get subtitle() {
		return this.$store.state.login.subtitle;
	}
}
